import classes from "./LoginWithUsernameForm.module.css";
import { useRef, useEffect } from "react";

function LoginWithUsernameForm({ setLoginOption }) {
  const usernameInputRef = useRef();
  const passInputRef = useRef();

  // Function to handle the form submission
  const handleInputChange = () => {
    const usernameValue = usernameInputRef.current.value;
    const passValue = passInputRef.current.value;

    // Only set login option if both fields have values
    if (usernameValue && passValue) {
      setLoginOption(usernameValue, passValue);
    }
  };

  const togglePassVis = () => {
    var passIn = document.getElementById("password");
    if (passIn.type === "password") passIn.type = "text";
    else passIn.type = "password";
  };

  return (
    <div className={classes.main}>
      <input
        type="text"
        placeholder="نام کاربری"
        className={classes.input}
        ref={usernameInputRef}
        required
        id="username"
        onChange={handleInputChange}
      />
      <input
        type="password"
        placeholder="کلمه عبور"
        className={classes.inputPass}
        ref={passInputRef}
        required
        onChange={handleInputChange}
        id="password"
      />
      <div className={classes.checkbox_container}>
        <input
          type="checkbox"
          className={classes.checkbox}
          onClick={togglePassVis}
        />
        <label htmlFor="checkbox">نمایش کلمه عبور</label>
      </div>
    </div>
  );
}

export default LoginWithUsernameForm;
